import { render, staticRenderFns } from "./PhoneVerifyStep.vue?vue&type=template&id=21a9910a&scoped=true"
import script from "./PhoneVerifyStep.vue?vue&type=script&lang=js"
export * from "./PhoneVerifyStep.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerifyStep.vue?vue&type=style&index=0&id=21a9910a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9910a",
  null
  
)

export default component.exports